import { ReactNode } from 'react';
import Box from '@mui/material/Box';
import Header from './Header';
import { AppSideMenu } from './AppSideMenu';
import Body from './Body';

/*
*   Главный слой приложения
*/

export type ILayout = {
    children?: ReactNode,
}


export default function Layout({ children }: ILayout) {
    return (
        <Box sx={{ display: 'flex' }}>
            <Header />

            <AppSideMenu />

            <Body>{children}</Body>
        </Box>
    );
}
